import { render, staticRenderFns } from "./processos.vue?vue&type=template&id=252e6ce8"
import script from "./processos.vue?vue&type=script&lang=js"
export * from "./processos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports